import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PanelState } from 'components/KBQSelect'

const initialState: PanelState[] = []

const KBQPanelStateSlices = createSlice({
  name: 'accrodionPanels',
  initialState,
  reducers: {
    setKBQPanelState(state, action: PayloadAction<PanelState>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
    clearKBQPanelState() {
      return []
    },
    clearAllHiddenPanels(state) {
      return state.filter(({ id }) => !id?.endsWith('_hidden'))
    },
  },
})

export const { setKBQPanelState, clearKBQPanelState, clearAllHiddenPanels } =
  KBQPanelStateSlices.actions

export default KBQPanelStateSlices.reducer
